import ArticleInformation from "../../types/ArticleInformation";

export const articleParamReducer = (
  state = null,
  action: any
): ArticleInformation | null => {
  switch (action.type) {
    case 'AddArticleParam':
      return {
        idPivot: action?.payload?.idPivot,
        idCodeGesco: action?.payload?.idCodeGesco,
        idOPeration: action?.payload?.idOPeration,
        idSociete: action?.payload?.idSociete,
        idClient: action?.payload?.idClient,
      };
    case 'DeleteArticleParam':
      return null;
    default:
      return state;
  }
};
